<!--商品上架组件-->
<template>
    <div>
      <!--面包屑导航区域-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品列表</el-breadcrumb-item>
      </el-breadcrumb>
      <!--搜索栏区域-->
      <el-row :gutter="20" class="search">
        <el-col :span="11">
          <!--<el-input placeholder="请选择查看店铺">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>-->
          <el-select v-model="shopId" placeholder="请选择店铺">
            <el-option v-for="item in shopNameList" :key="item.id" :label="item.shopName" :value="item.id"></el-option>
          </el-select>
          <el-button icon="el-icon-search" @click="searchCategoriesList">搜索</el-button>
          <el-button type="primary" @click="toAddCategories" icon="el-icon-plus">添加商品</el-button>
        </el-col>
      </el-row>
      <!--上架商品列表表格区域-->
      <el-table :data="goodList.slice((currentPage-1) * pageSize,currentPage * pageSize)" stripe border style="width: 100%">
        <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
        <el-table-column label="商品图片" align="center">
          <!-- 图片的显示 -->
          <template  slot-scope="scope">
            <img :src="scope.row.mainImage"  min-width="50" height="60" />
          </template>
        </el-table-column >
        <el-table-column prop="normalPrice" label="普通价格" align="center"></el-table-column>
        <el-table-column prop="promotionPrice" label="促销价格" align="center"></el-table-column>
        <el-table-column prop="sales" label="已售数量" align="center"></el-table-column>
        <el-table-column prop="stock" label="库存数量" align="center"></el-table-column>
        <el-table-column prop="status" label="商品状态" align="center">
          <!--上下架状态切换-->
          <template scope="scope">
            <el-button v-if="scope.row.status == 1" type="success" @click="goodStatusChange(scope.row)">上架中</el-button>
            <el-button v-if="scope.row.status == 0" type="info" @click="goodStatusChange(scope.row)">已下架</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
          <!--<el-button type="primary" @click="editCategoriesList">编辑</el-button>-->
          <el-button type="danger" @click="deleteCategories(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 商品列表编辑对话框-->
     <!-- <el-dialog title="商品编辑" :visible.sync="dialogFormVisible">
        <el-form :model="">
          <el-form-item label="活动名称" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>-->
      <!--分页器-->
      <el-pagination background
                      layout="prev, pager, next"
                      :total="goodList.length"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      style="text-align: center;margin-top: 10px"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentPage" >
      </el-pagination>

    </div>
</template>

<script>
/* import goods from '../../assets/json/categoriesList' */
import request from '../../http/categories'
// console.log(goods)
export default {
  name: 'OnCategoriesList',
  inject: ['reload'],
  data () {
    return {
      goodList: [], /* 表格商品列表数据 */
      currentPage: 1, // 初始页
      pageSize: 6, //    每页的数据
      shopNameList: [], // 店铺名数组
      shopId: '' // 店铺名对应id
    }
  },
  methods: {
    toAddCategories () { //  跳转到添加商品组件
      this.$router.push('/AddCategories')
      this.activePath = window.sessionStorage.setItem('activePath', '/AddCategories')
    },
    handleSizeChange (size) { // pageSize改变时触发
      this.pagesize = size
      // console.log('handleSizeChange')
    },
    handleCurrentPage (currentPage) { // 当前页面改变时触发
      // console.log(currentPage)
      this.currentPage = currentPage
      // console.log('handleCurrentPage')
    },
    editCategoriesList () {
    },
    async getShopIdList () { // 获取店铺列表
      const getShopNameData = {
        pageNum: 1,
        pageSize: 50,
        userName: window.sessionStorage.getItem('username')
      }
      // console.log(getShopNameData)
      const res = await request.getShopNameList(getShopNameData)
      // console.log(res.data.data.content[0].id)
      // console.log(res)
      this.shopNameList = res.data.data.content
    },
    async searchCategoriesList () { // 点击搜索，获取表格数据
      const res = await request.getTableList(this.shopId)
      // console.log(res)
      this.goodList = res.data.data
    },
    deleteCategories (row) { // 删除指定id商品
      this.$confirm('此操作将永久删除该商品信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const id = row.id
        request.deleteCategoriesId(id) // 删除请求
        // location.reload()// 刷新页面显示最新状态
        /* this.searchCategoriesList() */
        // this.reload() // 局部刷新这里
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    goodStatusChange (row) { // 修改商品上下架状态
      // console.log(row)
      /* 逻辑控制商品上下架状态 */
      if (row.status === 0) {
        row.status = 1
      } else if (row.status === 1) {
        row.status = 0
      }
      const sendData = {
        productId: row.id, // 商品id
        status: row.status // 状态为现在状态的相反数
      }
      // console.log(sendData)
      request.changeCategoriesStatus(sendData) // 发送请求
      // location.reload()// 刷新页面显示最新状态
    }
  },
  created () {
    this.getShopIdList() // 组件创建获取店铺名列表
  }
}
</script>

<style scoped>
.search{
  margin-bottom: 30px;
}
</style>
